module.exports = __webpack_public_path__ + "img/close-btn.8a77879a.svg";